import React, { useState } from 'react'
import { CCard, CCardBody, CForm, CLoadingButton } from '@coreui/react-pro'
import { useFormik } from 'formik'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'
import { formatValue } from './valueFormat'

// Values are what the API stores; do not change them.
const SYMBOLS = [
  { value: '€', label: 'Euro', code: 'EUR' },
  { value: '$', label: 'Dollar', code: 'USD' },
  { value: '£', label: 'Pound', code: 'GBP' },
  { value: '', label: 'None', code: 'Plain' },
]

const DefaultSalarySymbol = (props) => {
  const [loader, setLoader] = useState(false)
  const formik = useFormik({
    initialValues: {
      default_salary_symbol: props.defaultSalarySymbol ?? '',
    },
    enableReinitialize: true,
    onSubmit: (data) => {
      setLoader(true)
      CommonService.updateDefaultSalarySymbol(data)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            props.fetchData()
          } else {
            ToastComponent(res.message, 'error')
          }
        })
        .catch(() => ToastComponent('Could not update the currency symbol', 'error'))
        .finally(() => setLoader(false))
    },
  })

  const selected = formik.values.default_salary_symbol

  return (
    <CCard className="fv-card h-100">
      <CCardBody className="d-flex flex-column">
        <h2 className="fv-card-title">Currency Symbol</h2>
        <p className="fv-card-note">Shown in front of every player value.</p>

        <CForm onSubmit={formik.handleSubmit} className="d-flex flex-column flex-grow-1">
          <div className="fv-symbols" role="radiogroup" aria-label="Currency symbol">
            {SYMBOLS.map((s) => (
              <button
                key={s.code}
                type="button"
                role="radio"
                aria-checked={selected === s.value}
                className={`fv-symbol${selected === s.value ? ' active' : ''}`}
                onClick={() => formik.setFieldValue('default_salary_symbol', s.value)}
              >
                <span className="fv-symbol-glyph">{s.value || '—'}</span>
                <span className="fv-symbol-label">{s.label}</span>
              </button>
            ))}
          </div>

          <div className="fv-preview">
            Preview <strong>{formatValue(12.5, selected)}</strong>
          </div>

          <div className="fv-card-actions">
            <CLoadingButton
              type="submit"
              color="primary"
              loading={loader}
              disabled={!formik.dirty || loader}
            >
              Save Symbol
            </CLoadingButton>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  )
}

export default DefaultSalarySymbol
